import { useLocation, matchPath } from 'react-router-dom';

// ----------------------------------------------------------------------

export default function useActiveLink(path, deep = true) {
    const { pathname, search } = useLocation();

    // Split the configured path on '?' so matchPath only sees the pathname portion.
    // Some nav entries may include a query string (e.g. '?table=…'). Without this
    // split, matchPath treats the literal query string as part of the pattern and
    // never matches the pathname.
    const [pathPart, queryPart] = path ? path.split('?') : [path, undefined];

    const normalActive = pathPart ? !!matchPath({ path: pathPart, end: true }, pathname) : false;

    const deepActive = pathPart ? !!matchPath({ path: pathPart, end: false }, pathname) : false;

    // If the configured path includes a query string, additionally require all its
    // params to be present in the current location.search. This prevents the plain
    // Dashboard entry (pathname-only) from being affected — it has no queryPart so
    // falls through to the existing pathname-only behaviour, unchanged.
    const pathMatch = deep ? deepActive : normalActive;
    const queryMatch = queryPart
        ? Array.from(new URLSearchParams(queryPart).entries()).every(
              ([key, value]) => new URLSearchParams(search).get(key) === value
          )
        : true;

    return {
        active: pathMatch && queryMatch,
        isExternalLink: path.includes('http'),
    };
}
